var powerPlatformProducts = [
    {
        title: 'Power BI visuals',
        icon: 'PowerBI',
        description: 'Find visuals to bring your data to life with stunning, interactive data visualizations tailored to your organization and industry.',
        navigateOptions: {
            type: 'App',
            query: {
                product: 'power-bi-visuals'
            }
        }
    },
    {
        title: 'Power Apps',
        icon: 'PowerApps',
        description: 'Enhance Power Apps to build the business apps you need, and extend or customize the apps you already use.',
        navigateOptions: {
            type: 'App',
            query: {
                product: 'powerapps'
            }
        }
    },
    {
        title: 'Power Automate apps',
        icon: 'PowerAutomate',
        description: 'Empower everyone to automate workflows with a single low-code, user-friendly platform.',
        navigateOptions: {
            type: 'App',
            query: {
                product: 'power-automate'
            }
        }
    },
    {
        title: 'Power BI apps',
        icon: 'PowerBI',
        description: 'Enhance Power BI to connect your big data investments and empower teams to make data-driven, insights-based decisions.',
        navigateOptions: {
            type: 'App',
            query: {
                product: 'power-bi'
            }
        }
    },
    {
        title: 'Power Virtual Agents apps',
        icon: 'PowerVirtualAgents',
        description: 'Get tools to easily create intelligent, secure, and scalable virtual agents with a single low-code bot building platform.',
        navigateOptions: {
            type: 'App',
            query: {
                product: 'power-virtual-agents'
            }
        }
    },
    {
        description: 'Find apps to help quickly create secure, low-code websites.',
        title: 'Power Pages apps',
        navigateOptions: {
            type: 'App',
            query: {
                product: 'powerpages'
            }
        },
        icon: 'PowerPages'
    }
];

export { powerPlatformProducts };
